import { ComboboxInput } from '@headlessui/react';

import Props from '@/components/@base/input/combobox/input/type';

const Input = ({ className, ...props }) => {
  return <ComboboxInput className={className} {...props} />;
};

export default Input;
